import { ProductTokens } from '../types'
import { colors } from './colors'
import type { TheWestPalette } from './colors'

export const thewest: ProductTokens<TheWestPalette> = {
    colors,
}
